"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _BaseSelect = _interopRequireDefault(require("./BaseSelect"));

var _LabeledSelectModule = _interopRequireDefault(require("./LabeledSelect.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var LabeledSelect = function LabeledSelect(_ref) {
  var options = _ref.options,
      labelOnRight = _ref.labelOnRight,
      selectElement = _ref.selectElement,
      className = _ref.className,
      labelClassName = _ref.labelClassName,
      props = _objectWithoutProperties(_ref, ["options", "labelOnRight", "selectElement", "className", "labelClassName"]);

  return _react.default.createElement(_BaseSelect.default, _extends({
    options: options.map(function (option) {
      var content = option.content || option;
      var index = option.index || option;
      return {
        index: index,
        content: _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("span", {
          className: "".concat(_LabeledSelectModule.default.label, " ").concat(labelClassName)
        }, content), selectElement)
      };
    }),
    className: "".concat(className, " ").concat(labelOnRight ? _LabeledSelectModule.default.right : '')
  }, props));
};

process.env.NODE_ENV !== "production" ? LabeledSelect.propTypes = {
  options: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
    index: _propTypes.default.any.isRequired,
    content: _propTypes.default.any.isRequired
  })])).isRequired,
  selectElement: _propTypes.default.element.isRequired,
  labelOnRight: _propTypes.default.bool,
  className: _propTypes.default.string,
  labelClassName: _propTypes.default.string
} : void 0;
LabeledSelect.defaultProps = {
  labelOnRight: false,
  className: '',
  labelClassName: ''
};
var _default = LabeledSelect;
exports.default = _default;